import React from 'react';
import { ButtonComp } from 'atoms/Buttons';

const ActiveOrdersItems = props => {
  return (
    props?.orderHistoryReducer &&
    props?.orderHistoryReducer?.activeOrderHistory &&
    props?.orderHistoryReducer?.activeOrderHistory.map(postActiveOrderDetail => (
      <div className='active-orders-panel col-12 col-lg-7'>
        <div class='circle-top-left'></div>
        <div className='active-orders-details'>
          <div className='active-orders-details-info col-12'>
            <span>{props?.getTitle(postActiveOrderDetail)}</span>
          </div>
          <div className='active-orders-details-panel col-12'>
            <div className='active-orders-details-panel-info col-12 col-lg-8'>
              <span className='col-12'>{props?.getInfo(postActiveOrderDetail)}</span>
            </div>
            <div className='active-track-order-btn col-12 col-lg-4'>
              <ButtonComp
                data-testid='active-track-order-button'
                className='button col-12'
                aria-label={props?.getBtnTxt(postActiveOrderDetail)}
                onClickHandler={() => props?.onTrackOrderBtnClickHandler(postActiveOrderDetail)}
                id='activeTrackOrderItemButton'
                type='submit'
              >
                <span>{props?.getBtnTxt(postActiveOrderDetail)}</span>
              </ButtonComp>
            </div>
          </div>
          <div className='active-orders-details-add-info col-12'>
            <span>{props?.getAdditionalInfo(postActiveOrderDetail)}</span>
          </div>
        </div>
        <div class='circle-bottom-right'></div>
      </div>
    ))
  );
};

export default React.memo(ActiveOrdersItems);
